import {JavascriptCallOnSetSessionParametersFactory} from "./JavascriptCallOnSetSessionParametersFactory";
import {EnvGlobalsHandler} from "../../../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../../../IEnvironmentGlobals";
import {BasicController} from "../../../controller/BasicController";
import {ExternalInterfaceController} from "../../../controller/externalInterface/ExternalInterfaceController";
import {FlashCallbackFunctionName} from "../../../controller/externalInterface/FlashCallbackFunctionName";
import {JavascriptFunctionName} from "../../../controller/externalInterface/JavascriptFunctionName";
import {SocialDataEvent} from "../../../event/SocialDataEvent";
import {BasicModel} from "../../BasicModel";
import {getLogger} from "@goodgamestudios/logger";


import {ExternalInterface} from "@goodgamestudios/createjs-utilities";
const logger = getLogger("CoreJS.BasicSocialData");

export class BasicSocialData {
    public static LOGIN_RELOGIN_COUNT_MAX_TRIES: number = 3;

    public static INVITE: string = "invite";
    public static RELOAD: string = "reload";
    public static EXTERNAL_TRIGGER_ERROR: string = "triggerError";

    // Name of the social player that is shown on the social startscreen. Either shows the name of the player if he has an account or it is empty
    // which means the player hasn't an account for the current instance.
    private _displayNameExistingPlayer: string = "";

    // Hash key needed for the social login. The key is generated by PHP. Initially it is set via the Flashvar "suk".
    // Since the key is only temporarily valid it may get outdated while the social login process or the client have to request a new one
    // when the user logs out
    private _supportKey: string;

    // Hash key needed for the social login. The key is generated by PHP. Initially it is set via the Flashvar "sig".
    // Since the key is only temporarily valid it may get outdated while the social login process or the client have to request a new one
    // when the user logs out
    private _signatureKey: string;

    public socialLoginReloginCount: number = 0;

    public inviteFriends(): void {
        if (this.env.hasNetworkBuddies) {
            this.externalInterface(BasicSocialData.INVITE);
        }
    }

    public reloadIFrame(): void {
        this.externalInterface(BasicSocialData.RELOAD);
    }

    public setSocialData(playerID: number, username: string): void {
        ExternalInterfaceController.instance.executeJavaScriptFunction(new JavascriptCallOnSetSessionParametersFactory(playerID));
    }

    protected externalInterface(type: string, params: any[] = null): void {

        switch (type) {
            case BasicSocialData.INVITE:
            case BasicSocialData.RELOAD:
                ExternalInterface.call(type);
                break;
            case BasicSocialData.EXTERNAL_TRIGGER_ERROR:
                ExternalInterface.call(type, params[0], params[1]);
                break;
        }

    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public setDisplayNameExistingPlayer(value: string): void {
        this._displayNameExistingPlayer = (value) ? value : "";

        // Update view with the username sent be server
        let e: SocialDataEvent = new SocialDataEvent(SocialDataEvent.SOCIAL_PLAYER_NAME_CHANGED);
        e.playerName = BasicModel.socialData.displayNameExistingPlayer;
        BasicController.getInstance().dispatchEvent(e);
    }

    public get displayNameExistingPlayer(): string {
        return this._displayNameExistingPlayer;
    }

    /**
     * Refreshes the login keys signature key (sig) and support key (suk). The new keys are generated by PHP and delivered with a Javascript Call.
     * First the flash callback "setLoginKeys(sig:String,suk:String) is registered and after that the keys are requested by invoking "requestLoginKeys()"
     */
    public requestLoginKeys(): void {
        logger.info("Request new login keys from PHP");


        // Listen for a new set support key
        ExternalInterface.addCallback(FlashCallbackFunctionName.SET_LOGIN_KEYS, this.onSetLoginKeys);

        // Invoke Javascript function to request a new support key
        ExternalInterface.call(JavascriptFunctionName.REQUEST_LOGIN_KEYS);

    }

    /**
     * Gets triggered when Javascript invokes the "setSupportKey(supportKey)" callback.
     * Delivers a fresh generated signature and support key which are needed for the social login.
     *
     * @param signatureKey By PHP refreshed sig
     * @param supportKey By PHP refreshed suk
     */
    private onSetLoginKeys(signatureKey: string, supportKey: string): void {
        logger.info("Login keys refreshed, sig: " + signatureKey + ", suk: " + supportKey);

        this._signatureKey = signatureKey;
        this._supportKey = supportKey;

        // Set the updated values also in environment globals
        // TODO: Replace BasicEnvironmentGlobals accesses to "sig"/"suk" in client
        this.env.sig = this._signatureKey;
        this.env.suk = this._supportKey;

        let e: SocialDataEvent = new SocialDataEvent(SocialDataEvent.LOGIN_KEYS_REFRESHED);
        e.signatureKey = this._signatureKey;
        e.supportKey = this._supportKey;
        BasicController.getInstance().dispatchEvent(e);
    }

    /**
     * Indicates if the client should support a logout button or not.
     * A logout must be possible if the current network contains more than one instance
     * @return Logout supported or not
     */
    public logoutSupported(): boolean {
        return BasicModel.instanceProxy.instanceMap.length > 1;
    }

    public get supportKey(): string {
        return this._supportKey;
    }

    public get signatureKey(): string {
        return this._signatureKey;
    }
}
